module.exports = __webpack_public_path__ + "./docs/img/icon-var.fcfbf20c9fdd6c93998f67a847b15586.svg";